import AsyncStorage from '@react-native-async-storage/async-storage';
import { useCallback } from 'react';

export function useStoredCounter() {
  const getCounter = useCallback(async (id: string) => {
    const storageId = `${id}-counter`;
    const counterStr = await AsyncStorage.getItem(storageId);
    const counter = +(counterStr || 0) + 1;
    AsyncStorage.setItem(storageId, `${counter}`);
    return counter;
  }, []);

  return {
    getCounter,
  };
}
